import {
  GET_PRINT_TYPES_FAIL,
  GET_PRINT_TYPES_LIST,
  GET_PRINT_TYPES_SUCCESS,
} from "src/constants/types";

export const printTypesReducers = (state = {}, actions) => {
  switch (actions.type) {
    case GET_PRINT_TYPES_LIST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case GET_PRINT_TYPES_SUCCESS:
      return {
        ...state,
        loading: false,
        print_types: actions.payload,
        error: "",
      };

    case GET_PRINT_TYPES_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
